import { Component, OnInit } from '@angular/core';
import { specification } from 'src/app/service/modal/specification';
import { SpecificationService } from 'src/app/service/apiservice/specification.service';
import { Globals } from '../../../globals';
import { Router } from '@angular/router';
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-specification',
  templateUrl: './specification.component.html',
  styleUrls: ['./specification.component.css']
})
export class SpecificationComponent implements OnInit {

  specificationGrid:specification[]=new Array();

  constructor(private router:Router, private _specificationService:SpecificationService,private global:Globals) { }

  ngOnInit() {
    debugger;
    localStorage.setItem("Active Route",this.router.url);
    this.global.afterRefreshPageSetToken();
    this.GetSpec_List();
  }

  GetSpec_List()
  {
    this._specificationService.GetSpecificationList()
    .subscribe((response)=>
    {
      Object.assign(this.specificationGrid,response);
    },
    error=>
    {
       info_noti(error);
    })
  }

}
